import type { ModelFrom } from '@efdigital/ll-admin-v2/lib/type-utils';
import type ProgramsProgramCohortRoute from '@efdigital/ll-admin-v2/routes/programs/program/cohort';
import { array } from '@ember/helper';
import { LinkTo } from '@ember/routing';
import Component from '@glimmer/component';

interface ScheduleSignature {
  Args: {
    model: ModelFrom<ProgramsProgramCohortRoute> & {
      calendar_item_id?: string;
      message_id?: string;
    };
  };
}

export default class ScheduleBreadcrumb extends Component<ScheduleSignature> {
  get showAnnouncement() {
    return this.args.model.message_id;
  }

  get showCalendarItem() {
    return this.args.model.calendar_item_id;
  }

  <template>
    <div class="container-fluid">
      <div
        class="d-flex justify-content-center flex-row py-3 align-items-center gap-3"
      >
        <ol class="breadcrumb ll-content-breadcrumb m-0 justify-content-center">
          <li class="breadcrumb-item">
            <LinkTo
              @route="programs.program.cohort.schedule.index"
              @models={{array @model.program_id @model.cohort_id}}
              class="btn btn-outline-dark border-0 btn-sm rounded-1"
            ><strong>Schedule</strong> &ndash; {{@model.cohort.title}}</LinkTo>
          </li>
          {{#if this.showCalendarItem}}
            <li class="breadcrumb-item">
              <span
                class="btn btn-outline-dark border-0 btn-sm rounded-1"
              ><strong>Event</strong> &ndash; <em>Editing</em></span>
            </li>
          {{/if}}
          {{#if this.showAnnouncement}}
            <li class="breadcrumb-item">
              <span
                class="btn btn-outline-dark border-0 btn-sm rounded-1"
              ><strong>Announcement</strong>
                &ndash;
                <em>Editing</em></span>
            </li>
          {{/if}}
        </ol>
      </div>
    </div>
  </template>
}
